export var NodeEnv;
(function (NodeEnv) {
    NodeEnv["Development"] = "development";
    NodeEnv["ReplDevelopment"] = "repl-development";
    NodeEnv["Staging"] = "staging";
    NodeEnv["ReplStaging"] = "repl-staging";
    NodeEnv["Production"] = "production";
    NodeEnv["ReplProduction"] = "repl-production";
})(NodeEnv || (NodeEnv = {}));
export const DevEnvs = [NodeEnv.Development, NodeEnv.ReplDevelopment];
export const StagingEnvs = [NodeEnv.Staging, NodeEnv.ReplStaging];
export const ProdEnvs = [NodeEnv.Production, NodeEnv.ReplProduction];
export const ReplEnvs = [NodeEnv.ReplDevelopment, NodeEnv.ReplStaging, NodeEnv.ReplProduction];
//# sourceMappingURL=node-env.const.js.map